import { render, staticRenderFns } from "./institutionalaccreditation.vue?vue&type=template&id=3a5d909b&scoped=true"
import script from "./institutionalaccreditation.vue?vue&type=script&lang=js"
export * from "./institutionalaccreditation.vue?vue&type=script&lang=js"
import style0 from "./institutionalaccreditation.vue?vue&type=style&index=0&id=3a5d909b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5d909b",
  null
  
)

export default component.exports